import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { AppConfigService } from 'src/app/services/app-config.service';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-payment-successful',
  templateUrl: './payment-successful.component.html',
  styleUrls: ['./payment-successful.component.scss']
})
export class PaymentSuccessfulComponent implements OnInit, OnDestroy {
  private paramsSubscription?: Subscription;
  private queryParamsSubscription?: Subscription;

  public type: string = '';
  public receiptId: string = '';
  
  constructor(
    private appConfigService: AppConfigService,
    private configurationService: ConfigurationService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.paramsSubscription = this.route.paramMap.subscribe({
      next: (params) => this.type = params.get('type') ?? ''
    });
    this.queryParamsSubscription = this.route.queryParamMap.subscribe({
      next: (params) => this.receiptId = params.get('receiptId') ?? ''
    });
  }

  ngOnDestroy(): void {
    this.paramsSubscription?.unsubscribe();
    this.queryParamsSubscription?.unsubscribe();
  }

  public isIntercollAustralianVersion(): boolean {
    return this.appConfigService.getConfig().htmlVersion === 'version1' && this.appConfigService.getConfig().country === 'AU';
  }

  public getBankList(): Array<{ name: string, url: string }> {
    const result: Array<{ name: string, url: string }> = [];

    if (this.isIntercollAustralianVersion()) {
      result.push({ name: 'ANZ', url: 'https://login.anz.com/internetbanking' });
      result.push({ name: 'Commonwealth', url: 'https://www.my.commbank.com.au/netbank/Logon/Logon.aspx' });
      result.push({ name: 'NAB', url: 'https://ib.nab.com.au/login' });
      result.push({ name: 'Westpac', url: 'https://banking.westpac.com.au/wbc/banking/handler?TAM_OP=login&segment=personal&logout=false' });
    } else {
      switch (this.type) {
        case 'arrangementmanualnz':
          result.push({ name: 'ANZ New Zealand', url: 'https://www.anz.co.nz/' });
          result.push({ name: 'ASB Bank', url: 'https://www.asb.co.nz/' });
          result.push({ name: 'Bank of New Zealand', url: 'https://www.bnz.co.nz/' });
          result.push({ name: 'Kiwibank', url: 'https://www.kiwibank.co.nz/' });
          result.push({ name: 'Westpac New Zealand', url: 'https://www.westpac.co.nz/' });
          break;
        case 'arrangementmanualau':
        case 'arrangementbpayau':
          result.push({ name: 'Commonwealth', url: 'https://www.commbank.com.au/' });
          result.push({ name: 'ANZ', url: 'https://www.anz.com.au/' });
          result.push({ name: 'NAB', url: 'https://www.nab.com.au/' });
          result.push({ name: 'Westpac', url: 'https://www.westpac.com.au/' });
          result.push({ name: 'Suncorp', url: 'https://www.suncorp.com.au/' });
          break;
      }
    }

    return result;
  }

  public isEmailReceiptVisible(): boolean {
    return !_.isNil(this.receiptId) && this.receiptId !== '';
  }

  public isSearchLinkVisible(): boolean {
    return !this.configurationService.isCollexusVersion();
  }

  public getSearchLink(): string {
    let result = 'https://www.google.com.au';

    if (!this.isIntercollAustralianVersion()) {
      switch (this.type) {
        case 'arrangementmanualnz':
          result = 'https://www.google.co.nz';
          break;
      }
    }

    return result;
  }
}
